import { render, staticRenderFns } from "./exProposal.vue?vue&type=template&id=3ef120f6"
import script from "./exProposal.vue?vue&type=script&lang=js"
export * from "./exProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports